<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    width="780px"
    center
  :append-to-body="true"
    :lock-scroll="false"
    custom-class="message-dialog"
    @closed="handleClosed"
  >
    <button type="button" class="message-dialog__close" aria-label="关闭" @click="dialogVisible = false">
      <i class="el-icon-close" />
    </button>

    <div class="message-dialog__body">
      <div class="message-dialog__header">
        <h2 class="message-dialog__title">我要留言</h2>
        <p class="message-dialog__subtitle">该数据库仅供参考，如有不当请沟通反馈</p>
      </div>

      <el-form ref="formRef" :model="form" :rules="rules" class="message-dialog__form">
        <el-form-item prop="content" class="message-dialog__field">
          <div class="message-dialog__input-box message-dialog__input-box--textarea">
            <el-input
              v-model="form.content"
              type="textarea"
              style="width: 100%;"
              :rows="8"
              resize="none"
              placeholder="请输入留言内容"
            />
          </div>
        </el-form-item>

        <el-form-item prop="email" class="message-dialog__field">
          <div class="message-dialog__input-box">
            <el-input v-model="form.email" style="width: 100%;" placeholder="请输入邮箱" />
          </div>
        </el-form-item>

        <button
          type="button"
          class="message-dialog__submit"
          :disabled="submitting"
          @click="handleSubmit"
        >
          {{ submitting ? '提交中...' : '提交留言' }}
        </button>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { submitMessage } from '@/api/message'

export default {
  name: 'MessageDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      form: {
        content: '',
        email: ''
      },
      rules: {
        content: [{ required: true, message: '请输入留言内容', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    dialogVisible(visible) {
      this.setBodyScrollLock(visible)
    }
  },
  beforeDestroy() {
    this.setBodyScrollLock(false)
  },
  methods: {
    setBodyScrollLock(locked) {
      document.body.style.overflow = locked ? 'hidden' : ''
      if (!locked) {
        document.body.style.paddingRight = ''
      }
    },
    handleClosed() {
      this.setBodyScrollLock(false)
      this.form = { content: '', email: '' }
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
    },
    handleSubmit() {
      if (!this.$refs.formRef) return

      this.$refs.formRef.validate((valid) => {
        if (!valid) return

        this.submitting = true
        submitMessage({
          content: this.form.content,
          email: this.form.email
        })
          .then((res) => {
            if (res && (res.code === 2000 || res.code === 2001)) {
              this.$message.success('留言提交成功，感谢您的反馈')
              this.dialogVisible = false
            } else {
              this.$message.error((res && res.message) || '留言提交失败，请稍后重试')
            }
          })
          .catch(() => {})
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style lang="scss">
.v-modal {
  background-color: rgba(61, 43, 40, 0.72) !important;
  backdrop-filter: blur(4px);
}

.message-dialog {
  background: transparent;
  box-shadow: none;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.message-dialog {
  &__close {
    position: absolute;
    top: $spacing-base;
    right: $spacing-base;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: rgba($color-white, 0.7);
    font-size: rem(18);
    transition: all 0.2s;

    &:hover {
      color: $color-white;
      background: rgba($color-white, 0.12);
    }
  }

  &__body {
    position: relative;
    padding: $spacing-3xl $spacing-2xl $spacing-2xl;
    background:
      url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.06'/%3E%3C/svg%3E"),
      linear-gradient(160deg, rgba($color-brown-dark, 0.98) 0%, rgba($primary-color, 0.96) 50%, rgba($color-brown-footer, 0.98) 100%);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background:
        radial-gradient(ellipse at 30% 20%, rgba($color-paper, 0.08) 0%, transparent 60%),
        radial-gradient(ellipse at 80% 80%, rgba($success-color, 0.06) 0%, transparent 50%);
      pointer-events: none;
    }
  }

  &__header {
    position: relative;
    text-align: center;
    margin-bottom: $spacing-2xl;
  }

  &__title {
    font-family: $font-serif;
    font-size: rem(32);
    font-weight: 700;
    color: $color-white;
    letter-spacing: 4px;
    line-height: 1.3;
  }

  &__subtitle {
    margin-top: $spacing-md;
    font-size: rem(13);
    color: rgba($color-white, 0.75);
    letter-spacing: 1px;
  }

  &__form {
    position: relative;

    ::v-deep .el-form-item {
      margin-bottom: $spacing-base;
    }

    ::v-deep .el-form-item__error {
      color: #fff;
      padding-left: $spacing-base;
    }
  }

  &__input-box {
    position: relative;
    background: $color-white;
    border-radius: 6px;
    overflow: hidden;
    width: 100%;
    &--textarea {
      width: 100%;
      ::v-deep .el-textarea__inner {
        min-height: 200px;
        padding: $spacing-2xl $spacing-base $spacing-base;
      }
    }

    ::v-deep .el-input__inner,
    ::v-deep .el-textarea__inner {
      box-shadow: none;
      width: 100%;
      background: transparent;
      padding: 10px;
      font-size: rem(14);
      color: $color-text;
      border: none;
    }

    ::v-deep .el-textarea__inner {
      width: 100%;
    }
  }

  &__label {
    position: absolute;
    top: $spacing-md;
    left: $spacing-base;
    z-index: 1;
    font-size: rem(14);
    color: $color-text-light;
    pointer-events: none;
  }

  &__submit {
    display: block;
    width: 100%;
    margin-top: $spacing-xl;
    padding: $spacing-md;
    background: $success-color;
    color: $color-white;
    font-size: rem(16);
    letter-spacing: 2px;
    border-radius: 6px;
    transition: background 0.25s $ease-apple, opacity 0.2s;

    &:hover:not(:disabled) {
      background: $color-green-light;
    }

    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
    }
  }
}

@media (max-width: 680px) {
  .message-dialog {
    &__body {
      padding: $spacing-2xl $spacing-base $spacing-base;
    }

    &__title {
      font-size: rem(26);
    }
  }
}
</style>
